import { useEffect } from 'react';
import useOutsideClick from '../../../hooks/useOutsideClick';
const useCloseOnOutsideClick = ({ isToggled, setOff }) => {
    const [ref, isOutsideClick] = useOutsideClick(isToggled);
    useEffect(() => {
        if (isOutsideClick) {
            setOff();
        }
    }, [setOff, isOutsideClick]);
    return { ref };
};
export default useCloseOnOutsideClick;
//# sourceMappingURL=useCloseOnOutsideClick.js.map